import script from "./ExtraGuardianCertFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtraGuardianCertFields.vue?vue&type=script&setup=true&lang=ts"

import "./ExtraGuardianCertFields.vue?vue&type=style&index=0&id=3c4911f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4911f1"]])

export default __exports__